module.exports = __webpack_public_path__ + "img/menu03.f825447f.jpg";